import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import { TripItem } from 'tripPlanner/types/tripItem'
import DateTimeBlock from './DateTimeBlock'

const DateTimeDisplay = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${rem(20)};
  width: 100%;
`

const Mid = styled.div`
  display: flex;
  align-items: center;
`

type Props = {
  startTitle: string
  endTitle: string
  item: TripItem
}
function StartAndEndDateTime({ startTitle, endTitle, item }: Props) {
  const { startDate, startTime, startDay, endDay } = item
  const endDate = 'endDate' in item ? item.endDate : undefined
  const endTime = 'endTime' in item ? item.endTime : undefined
  const haveBothStartAndEndDate = (startDate && endDate) || (startDay && endDay)
  if (haveBothStartAndEndDate) {
    return (
      <DateTimeDisplay>
        <DateTimeBlock
          title={startTitle}
          date={startDate}
          time={startTime}
          day={startDay}
        />
        <Mid>
          <LineArrowRightIcon colour="neutral-two" />
        </Mid>
        <DateTimeBlock
          title={endTitle}
          date={endDate}
          time={endTime}
          day={endDay}
        />
      </DateTimeDisplay>
    )
  }

  return (
    <>
      <DateTimeBlock
        title={startTitle}
        date={startDate}
        time={startTime}
        day={startDay}
      />
      <DateTimeBlock
        title={endTitle}
        date={endDate}
        time={endTime}
        day={endDay}
      />
    </>
  )
}
export default StartAndEndDateTime
